import { clientApi } from '@/config/axios';

export interface ValidateInvitationResponse {
  already_has_account: boolean;
  email: string | null;
  name: string | null;
  organization_name: string | null;
  valid: boolean;
}

export async function setPassword(token: string, password: string): Promise<{ success: boolean }> {
  const { data } = await clientApi.post<{ success: boolean }>(
    '/api/v1/auth/set-password',
    { token, password },
  );
  return data;
}

export async function validateInvitation(token: string): Promise<ValidateInvitationResponse> {
  const { data } = await clientApi.post<ValidateInvitationResponse>(
    '/api/v1/auth/validate-invitation',
    { token },
  );
  return data;
}
